"use client";

import { useEffect, useState } from "react";

// ============================================
// MANUAL CONFIGURATION - Update these values
// ============================================
export const ATTENDEE_COUNT = 218;
export const KOMMERS_COUNT = 215;
export const CHARGIERTE_COUNT = 50;
export const BALL_COUNT = 140;
// ============================================

export const EVENT_DATE = new Date("2026-06-11T00:00:00");

export function useAnimatedCounter(
  end: number,
  duration: number = 2000,
  startAnimation: boolean = false
) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!startAnimation) return;

    let startTime: number | null = null;
    let animationFrame: number;

    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);

      // Easing function - easeOutQuad for snappier finish
      const easeOutQuad = 1 - Math.pow(1 - progress, 2);
      setCount(Math.floor(easeOutQuad * end));

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [end, duration, startAnimation]);

  return count;
}

export function calculateDaysUntil(targetDate: Date): number {
  const now = new Date();
  const diffTime = targetDate.getTime() - now.getTime();
  return Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));
}
